
import React from 'react';
import { TailSpin } from 'react-loader-spinner'
import '../assets/css/spinner.css';
const Spinner = (props) => {
  return (
    <div className='spinnerbackground ' visible={props.visibility}>

      <div className='spinner-left'>
        <TailSpin
        height="40"
        width="40"
        color="#316AF7"
        ariaLabel="tail-spin-loading"
        radius="1"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
      </div>
    </div>
  );
}
export default Spinner;